export default "/app-page/javascript/public/images/MW_LR_Landscape_blk-c5f0424890621558.png"